/* Stylesheet */

.minimal_pie_chart {
  height: 100%;
  display: flex;
  align-items: center;

  .pie_chart {
    height: 121px;
    width: 121px;
  }

  .label_container {
    .label {
      padding: 12px 12px 12px 42px;
      display: flex;
      align-items: center;
      color: var(--ion-color-text-tertiary);

      .percentage {
        margin: 0px 16px 0px 0px;
      }
    }
  }
}

/* Media Queries */
@media screen and (min-width: 1536px) {
  .minimal_pie_chart {
    .pie_chart {
      height: 132px;
    }
  }
}
